import type { Quality } from './render'

export const PRICE_KEY = {
  welcome: 'welcome',
  convertStl: 'convert_stl',
  convertObj: 'convert_obj',
  ar: 'ar',
  bridgeConvert: 'bridge_convert',
  renderQuick: 'render_quick',
  renderHigh: 'render_high',
  renderUltra: 'render_ultra',
  thumbnail: 'thumbnail',
} as const

export type PriceKey = (typeof PRICE_KEY)[keyof typeof PRICE_KEY]

const RENDER_PRICE_KEY: Readonly<Record<Quality, PriceKey>> = {
  quick: PRICE_KEY.renderQuick,
  high: PRICE_KEY.renderHigh,
  ultra: PRICE_KEY.renderUltra,
}

export function renderPriceKey(quality: Quality): PriceKey {
  return RENDER_PRICE_KEY[quality]
}
